import { useState, useEffect } from 'react';
import { getNoAprobados } from '../../services/MpGeneral.service';

// Pagos de MP no aprobados del período. Independiente de useConciliacion:
// su carga o error no afecta a la conciliación.
export const useNoAprobadosMP = (empresa, desde, hasta, triggerRecarga) => {
  const [noAprobados, setNoAprobados] = useState([]);
  const [resumenNoAprobados, setResumenNoAprobados] = useState(null);
  const [cargandoNoAprobados, setCargandoNoAprobados] = useState(false);
  const [errorNoAprobados, setErrorNoAprobados] = useState(null);

  const cargarNoAprobados = async () => {
    setCargandoNoAprobados(true);
    setErrorNoAprobados(null);

    try {
      const response = await getNoAprobados(empresa, desde, hasta);

      if (response.success) {
        setNoAprobados(response.data || []);
        setResumenNoAprobados(response.resumen || null);
      } else {
        setErrorNoAprobados(response.error || 'Error al obtener pagos no aprobados');
      }
    } catch (error) {
      console.error('[useNoAprobadosMP] Error:', error);
      setErrorNoAprobados(error.message || 'Error al obtener pagos no aprobados');
    } finally {
      setCargandoNoAprobados(false);
    }
  };

  useEffect(() => {
    if (desde && hasta && empresa) {
      cargarNoAprobados();
    }
  }, [desde, hasta, empresa, triggerRecarga]);

  return {
    noAprobados,
    resumenNoAprobados,
    cargandoNoAprobados,
    errorNoAprobados,
    recargarNoAprobados: cargarNoAprobados,
  };
};
